import React from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import {OutRoute, ProtectedRoute} from 'navigation/RouteManager'
//screens
import Dashboard from 'screens/Dashboard'
import Login from 'screens/Auth/Login'
import ForgotPassword from 'screens/Auth/ForgotPassword'
import ResetPassword from 'screens/Auth/ResetPassword'
import Accounts from 'screens/Accounts'
import Account from 'screens/Account'
import Clients from 'screens/Clients'
// import Users from 'screens/Users'
// import User from 'screens/User'
import {useGetCurrentUserQuery} from 'store/Store'
import Client from 'screens/Client/Client'
import Settings from 'screens/Settings/Settings'
import Register from 'screens/Auth/Register'
import LoginDetails from 'components/Auth/Register/LoginDetails'

const navigationRouter = (
    <Router>
        <Routes>
            <Route element={<OutRoute />}>
                <Route exact path="/" element={<Login />} />
                <Route exact path="/login" element={<Login />} />
                <Route path="/register/:token" element={<LoginDetails />} />
                <Route path="/register" element={<Register />} />
                <Route
                    path="/resetPassword/:token"
                    element={<ResetPassword />}
                />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
            </Route>
            <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/account/:accountId" element={<Account />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/client/:clientId" element={<Client />} />
                <Route path="/settings" element={<Settings />} />
            </Route>
        </Routes>
    </Router>
)

const NavigationRouter = () => {
    const {data, error} = useGetCurrentUserQuery()
    console.log('navigation router', {data, error})
    return <div>{navigationRouter}</div>
}

export default NavigationRouter

const getRouterProtectedPaths = (router) => {
    const outlets = router.props.children.props.children

    const protectedOutlet = outlets.filter(
        (outlet) => outlet.props.element.type.name === ProtectedRoute.name
    )?.[0]

    return protectedOutlet.props.children.map((route) => route.props.path)
}

export const protectedPaths = getRouterProtectedPaths(navigationRouter)
